<template>
    <v-dialog v-model="isDialogOpen" width="800">
        <v-card>
            <v-toolbar flat>
                <v-toolbar-title>
                    <span class="font-weight-bold">{{ headerTitle }}</span>
                </v-toolbar-title>
                <v-toolbar-items class="pr-2 ml-auto">
                    <v-btn icon @click.native="$emit('close')">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-container>
                <partner-manufacturer-showcase-form :mode="mode" :initial-showcase="initialShowcase" @submitted="$emit('submitted', $event)"
                    @failed="$emit('failed', $event)"></partner-manufacturer-showcase-form>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>
import { PartnerManufacturerShowcaseForm } from '../../components/forms';
import { MixinDialogRemote } from '../../mixins';

export default {
    name: "PartnerManufacturerShowcaseDialog",
    components: {
        PartnerManufacturerShowcaseForm,
    },
    mixins: [MixinDialogRemote],
    props: {
        mode: {
            type: String,
            default: 'create',
        },
        initialShowcase: {
            type: Object,
            default: () => null,
        },
    },
    computed: {
        headerTitle() {
            if (this.mode === 'create') {
                return this.$t('addPartner');
            }

            return this.initialShowcase && this.initialShowcase.sourceType === 'manufacturer'
                ? this.$t('editManufacturer')
                : this.$t('editPartner');
        },
    },
}
</script>
